export enum BillingPermissionEnum {
    NOE = "NOE",
    NOTR = "NOTR",
    Claims = "Claims",
    History = "History",
    Remittance = "Remittance",
    OverrideClosedAccounting = "Override Closed Accounting",
    Collections = "Collections",
    ClaimNotes = "Claim Notes",
    CR8358Tool = "CR8358 Tool"
}
